export const TypographyTokens = {
  "fontsize": {
    "body": {
      "12": {
        "value": "0.75rem"
      },
      "14": {
        "value": "0.875rem"
      },
      "16": {
        "value": "1rem"
      }
    },
    "feature": {
      "40": {
        "value": "2.5rem"
      },
      "48": {
        "value": "3rem"
      },
      "64": {
        "value": "4rem"
      },
      "80": {
        "value": "5rem"
      },
      "96": {
        "value": "6rem"
      },
      "128": {
        "value": "8rem"
      },
      "144": {
        "value": "9rem"
      },
      "superscript": {
        "value": "50%"
      }
    },
    "micro": {
      "11": {
        "value": "0.6875rem"
      }
    },
    "title": {
      "16": {
        "value": "1rem"
      },
      "20": {
        "value": "1.25rem"
      },
      "24": {
        "value": "1.5rem"
      },
      "32": {
        "value": "2rem"
      },
      "40": {
        "value": "2.5rem"
      },
      "48": {
        "value": "3rem"
      },
      "64": {
        "value": "4rem"
      },
      "superscript": {
        "value": "50%"
      }
    }
  },
  "fontweight": {
    "light": {
      "value": 300
    },
    "regular": {
      "value": 400
    },
    "bold": {
      "value": 700
    }
  },
  "letterspacing": {
    "wide": {
      "value": "0.03125rem"
    },
    "semiwide": {
      "value": "0.015625rem"
    }
  },
  "lineheight": {
    "body": {
      "16": {
        "value": "1rem"
      },
      "18": {
        "value": "1.125rem"
      },
      "20": {
        "value": "1.25rem"
      }
    },
    "feature": {
      "40": {
        "value": "2.5rem"
      },
      "48": {
        "value": "3rem"
      },
      "64": {
        "value": "4rem"
      },
      "76": {
        "value": "4.75rem"
      },
      "88": {
        "value": "5.5rem"
      },
      "120": {
        "value": "7.5rem"
      },
      "136": {
        "value": "8.5rem"
      }
    },
    "micro": {
      "16": {
        "value": "1rem"
      }
    },
    "title": {
      "20": {
        "value": "1.25rem"
      },
      "24": {
        "value": "1.5rem"
      },
      "28": {
        "value": "1.75rem"
      },
      "36": {
        "value": "2.25rem"
      },
      "40": {
        "value": "2.5rem"
      },
      "48": {
        "value": "3rem"
      },
      "64": {
        "value": "4rem"
      }
    }
  }
}